import { FiltroReprogramacion } from './../../../models/FiltroReprogramacion';
import { CobranzasService } from './../../../services/cobranzas/cobranzas.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DatePipe } from '@angular/common';
import { MessagesTitles, MessagesGeneral, MessagesDates } from './../../../models/messages';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import * as moment from 'moment';
import Swal from "sweetalert2";
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};


@Component({
  selector: 'app-listado-reprogramacion',
  templateUrl: './listado-reprogramacion.component.html',
  styleUrls: ['./listado-reprogramacion.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,DatePipe,
    {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE]
      },
  
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
]
})
export class ListadoReprogramacionComponent implements OnInit {

  
Label_Proveedor=environment.LABEL_PROVEEDOR;
Label_Proveedores=environment.LABEL_PROVEEDORES;
Label_Adquirente=environment.LABEL_ADQUIRENTE;
Label_Adquirentes=environment.LABEL_ADQUIRENTES;

  DTOFiltrosReprogramacion: FiltroReprogramacion = new FiltroReprogramacion();

  today = moment();
  loading:boolean;
  TipoMoneda: any = ""; 
  abrirCancelarReprogramacion : boolean = false;
  abrirDetalleReprogramacion : boolean = false;
  filteredAdquirentes: Observable<any[]>;
  adquirentessArr;
  rucAdqTemporal : any;
  rucAdq = new FormControl();
  idAdq ="";
  idAdqui:any;
  RUC_ADQ : string;
  arrayReprogramacion :any=[];
  dataEnviar :any=[];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns = ['checked','idComprobante','idCobranza_Reprogramada','Nombre_Comercial','Fecha_Registro','Moneda','VNPP','Monto_Negociado','Estado']
  
  dataSource: any;

  constructor(private datepipe :DatePipe,private cobranzasService : CobranzasService) {

    this.DTOFiltrosReprogramacion.FechaInicio = this.datepipe.transform(moment().add(-30, 'day'),'yyyy-MM-dd');
    this.DTOFiltrosReprogramacion.FechaFin = this.datepipe.transform(moment(),'yyyy-MM-dd');
   }

  ngOnInit() {
    this.ObtenerAdquirentesCombo();
  }
  tipoMoneda(event){
    if(event==''){
      this.DTOFiltrosReprogramacion.Moneda = 0;
    }else{
      this.DTOFiltrosReprogramacion.Moneda = event;
    } 
  }
  ListadoCobranzaReprogramada(){
    this.DTOFiltrosReprogramacion.FechaInicio = this.datepipe.transform(this.DTOFiltrosReprogramacion.FechaInicio,'yyyy-MM-dd')
    this.DTOFiltrosReprogramacion.FechaFin = this.datepipe.transform(this.DTOFiltrosReprogramacion.FechaFin,'yyyy-MM-dd')
   
   this.loading = true;

   if (this.rucAdq.value == null || this.rucAdq.value == ""){
     this.idAdqui = "";
   }

   this.cobranzasService.ObtenerDocumentosReprogramados(this.DTOFiltrosReprogramacion).subscribe(
     res =>{
         this.arrayReprogramacion = res;
         this.dataSource = new MatTableDataSource( this.arrayReprogramacion);
         this.dataSource.sort = this.sort;
         this.dataSource.paginator = this.paginator;
         this.loading = false;
     },err =>{
         Swal.fire({
             title: "¡Algo salió mal!",
             text:  err.error['error'],
             type: "warning",
             allowOutsideClick: true,
             heightAuto: false 
         });
         this.loading = false;
     }
   )


  }

  obtenerRucAdq(termino :string){
    this.idAdq = termino;
  }
  obtenerIdAdq(idAd :number){
    this.idAdqui = idAd;
    this.DTOFiltrosReprogramacion.IdAdqui = this.idAdqui;
  }

  obtenerRucRazSocialAdq(termino :string = ''){
    
    if (termino != null && termino != ''){
          
      let termino1 = termino.toLowerCase();                   
  
      for( let p of this.adquirentessArr){
  
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
            
            this.idAdq = p.Num_Doc_Identificacion;

          }
      }

    }

  }

  ObtenerAdquirentesCombo() {
    
    this.adquirentessArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.rucAdq.valueChanges
    .pipe(
      startWith(""),
      map(state =>
        state ? this._filterAdq(state) : this.adquirentessArr.slice()
      )
    );
    
}

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.adquirentessArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  CancelarCobranzaReprogramada(element:any){
    this.abrirCancelarReprogramacion = true;
    this.cobranzasService.dataReprogramacion = element;
  }

  CerrarPopUpCanReprogramada(){
    this.abrirCancelarReprogramacion = false;

  }
  DetalleCobranzaReprogramada(element){
    this.abrirDetalleReprogramacion = true;
    this.cobranzasService.dataDetalleReprogramacion = element;
  }

  CerrarPopUpDetalleReprogramada(){
    this.abrirDetalleReprogramacion = false;
  }

}
